import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Input, Label, Row, } from "reactstrap";
import { useHistory } from "react-router-dom";
import { initialFiledFunc } from "../../components/Common/validationFunction";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId, url } from "../../routes/index"
import { MetaTags } from "react-meta-tags";
import { postInvoiceDataExport_API, postInvoiceDataExport_API_Success } from "../../store/Report/InvoiceDataExportRedux/action";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { globalTableSearchProps } from "../../components/Common/SearchBox/MySearch";
import { BreadcrumbShowCountlabel, commonPageField, commonPageFieldSuccess } from "../../store/actions";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import DynamicColumnHook from "../../components/Common/TableCommonFunc";
import { alertMessages } from "../../components/Common/CommonErrorMsg/alertMsg";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import GlobalCustomTable from "../../GlobalCustomTable";

const InvoiceDataExport = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func((localStorage.getItem("realTime")));
    const isSCMParty = _cfunc.loginIsSCMParty();
    const fileds = {
        FromDate: currentDate_ymd,
        ToDate: currentDate_ymd,
    }
    const [subPageMode] = useState(history.location.pathname);
    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [userPageAccessState, setUserAccState] = useState('');
    const [PartyDropdown, setPartyDropdown] = useState(allLabelWithZero);
    const [reportType, setReportType] = useState(true);


    const {
        userAccess,
        tableData = "",
        ExcelBtnLoading,
        GoBtnLoading,
        Distributor,
        pageField
    } = useSelector((state) => ({
        tableData: state.InvoiceDataExportReducer.InvoiceDataExportGobtn,
        GoBtnLoading: state.InvoiceDataExportReducer.GoBtnLoading,
        Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        ExcelBtnLoading: state.InvoiceDataExportReducer.ExcelBtnLoading,
        supplier: state.CommonAPI_Reducer.vendorSupplierCustomer,
        userAccess: state.Login.RoleAccessUpdateData,
        SSDD_List: state.CommonAPI_Reducer.SSDD_List,
        pageField: state.CommonPageFieldReducer.pageField
    })
    );

    const { Data = [], goBtnMode } = tableData;

    const values = { ...state.values }

    // Featch Modules List data  First Rendering
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    useEffect(() => {
        let pageID
        if (subPageMode === url.INVOICE_DATA_EXPORT) {
            pageID = pageId.INVOICE_DATA_EXPORT
        } else {
            pageID = pageId.PURCHASE_DATA_EXPORT
        }
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageID));
        dispatch(BreadcrumbShowCountlabel(`Count:${0}`));
        if (_cfunc.CommonPartyDropValue().value > 0) {
            setPartyDropdown(_cfunc.CommonPartyDropValue())
        }
        return () => {
            dispatch(commonPageFieldSuccess(null));
        }
    }, []);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    const [tableColumns] = DynamicColumnHook({ pageField })

    const displayColumns = React.useMemo(() => {
        if (subPageMode !== url.PURCHASE_DATA_EXPORT) {
            return tableColumns;
        }

        const isFranchiseParty = _cfunc.loginUserIsFranchisesRole();

        // Franchise -> show all columns
        if (isFranchiseParty) {
            return tableColumns;
        }

        // Non-franchise -> hide these columns
        return tableColumns.filter(
            ({ dataField }) =>
                ![
                    "LocationName",
                    "ItemPriceZOHO",
                    "TaxExemption",
                    "Irn",
                    "AckNo",
                    "EwayBillNo",
                ].includes(dataField)
        );
    }, [tableColumns, subPageMode]);
    useEffect(() => {
        return () => { dispatch(postInvoiceDataExport_API_Success([])); }
    }, [])

    // Excel column list: same visible columns as the table (uses displayColumns, no hardcoded list)
    const excelPageField = React.useMemo(() => {
        if (!pageField || subPageMode !== url.PURCHASE_DATA_EXPORT) return pageField;

        const visibleFields = new Set(displayColumns.map(c => c.dataField));

        return {
            ...pageField,
            PageFieldMaster: (pageField.PageFieldMaster || []).filter(f =>
                Object.values(f).some(v => visibleFields.has(v))
            ),
        };
    }, [pageField, displayColumns, subPageMode]);

    useEffect(() => {
        if (goBtnMode === "downloadExcel") {
            let excelName
            if (subPageMode === url.INVOICE_DATA_EXPORT) {
                excelName = "Invoice Data Export"
            } else {
                excelName = "Purchase Data Export"
            }
            if (Data.length > 0) {
                ExcelReportComponent({      // Download CSV
                    pageField: excelPageField,
                    excelTableData: Data,
                    excelFileName: excelName
                })
                dispatch(postInvoiceDataExport_API_Success([]));   // Reset Excel Data
            }
        }
    }, [goBtnMode, Data, excelPageField]);

    function goButtonHandler(goBtnMode) {

        try {
            let jsonBody

            if ((isSCMParty) && (PartyDropdown === "")) {
                customAlert({ Type: 3, Message: alertMessages.commonPartySelectionIsRequired });
                return;
            };

            if (subPageMode === url.PURCHASE_DATA_EXPORT) {
                jsonBody = JSON.stringify({
                    "FromDate": values.FromDate,
                    "ToDate": values.ToDate,
                    "Party": 0,
                    "Customer": (isSCMParty) ? PartyDropdown.value : _cfunc.loginPartyID(),
                    "Mode": 2,
                    "Employee": !isSCMParty ? 0 : _cfunc.loginEmployeeID(),
                    "ReportType": reportType

                });
            }
            else {
                jsonBody = JSON.stringify({
                    "FromDate": values.FromDate,
                    "ToDate": values.ToDate,
                    "Party": (isSCMParty) ? PartyDropdown.value : _cfunc.loginPartyID(),
                    "Customer": 0,
                    "Mode": 1,
                    "Employee": !isSCMParty ? 0 : _cfunc.loginEmployeeID(),

                });
            }

            const config = { jsonBody, goBtnMode: goBtnMode, btnId: goBtnMode };
            dispatch(postInvoiceDataExport_API(config))

        } catch (error) { _cfunc.CommonConsole(error) }
    }

    function fromdateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.FromDate = date;
            a.hasValid.FromDate.valid = true
            return a
        })
        dispatch(postInvoiceDataExport_API_Success([]))
    }

    function todateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.ToDate = date;
            a.hasValid.ToDate.valid = true
            return a
        })
        dispatch(postInvoiceDataExport_API_Success([]))
    }

    const partyOnchange = (e) => {
        setPartyDropdown(e)
        dispatch(postInvoiceDataExport_API_Success([]))
    }

    const Party_Option = Distributor.map(i => ({
        value: i.id,
        label: i.Name
    }));

    Party_Option.unshift({
        value: 0,
        label: " All"
    });

    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

            <div className="px-2   c_card_filter text-black " >
                <Row>
                    <Col sm={2} className="">
                        <FormGroup className=" row mt-2  " >
                            <Label className="col-sm-4 p-2"
                                style={{ width: "83px" }}>FromDate</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    name='FromDate'
                                    value={values.FromDate}
                                    onChange={fromdateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col sm={2} className="">
                        <FormGroup className=" row mt-2 " >
                            <Label className="col-sm-4 p-2"
                                style={{ width: "65px" }}>ToDate</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    name="ToDate"
                                    value={values.ToDate}
                                    onChange={todateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    {isSCMParty &&
                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2" >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px", marginRight: "20px" }}>Party</Label>
                                <Col sm="8">
                                    <Select
                                        name="Party"
                                        value={PartyDropdown}
                                        isSearchable={true}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        options={Party_Option}
                                        onChange={(e) => { partyOnchange(e) }}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    }

                    {subPageMode === url.PURCHASE_DATA_EXPORT && (
                        <Col sm={3}>
                            <FormGroup className="row mt-2">

                                <Label className="p-2" style={{ width: "110px" }}>
                                    Report Type
                                </Label>

                                <Col>
                                    <div
                                        className="btn-group col-xxl-12 mt-1"
                                        role="group"
                                        aria-label="Report type"
                                    >

                                        {/* Transaction */}
                                        <input
                                            type="checkbox"
                                            id="btncheckTransaction"
                                            className="btn-check"
                                            autoComplete="off"
                                            checked={reportType === true}
                                            onChange={() => setReportType(true)}
                                        />
                                        <label
                                            className="btn btn-outline-secondary"
                                            htmlFor="btncheckTransaction"
                                        >
                                            Transaction-Based
                                        </label>

                                        {/* GRN */}
                                        <input
                                            type="checkbox"
                                            id="btncheckGRN"
                                            className="btn-check"
                                            autoComplete="off"
                                            checked={reportType === false}
                                            onChange={() => setReportType(false)}
                                        />
                                        <label
                                            className="btn btn-outline-secondary"
                                            htmlFor="btncheckGRN"
                                        >
                                            GRN-Based
                                        </label>

                                    </div>
                                </Col>
                            </FormGroup>
                        </Col>
                    )}

                    <Col sm="auto" className="d-flex justify-content-end ms-auto">

                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading === "showOnTable"}
                            className="btn btn-success m-3 mr"
                            onClick={() => goButtonHandler("showOnTable")}
                        >
                            Show
                        </C_Button>
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={ExcelBtnLoading === "downloadExcel"}
                            className="btn btn-primary m-3 mr"
                            onClick={() => goButtonHandler("downloadExcel")}
                        >
                            Excel
                        </C_Button>
                    </Col>







                </Row>
            </div>






            <div className="mt-1">
                {/* <ToolkitProvider
                        keyField="PartyID"
                        data={Data}
                        columns={tableColumns}
                        search
                    >
                        {(toolkitProps,) => (
                            <React.Fragment>
                                <Row>
                                    <Col xl="12">
                                        <div className="table-responsive table">
                                            <BootstrapTable
                                                keyField="PartyID"
                                                classes={"table  table-bordered table-hover"}
                                                noDataIndication={
                                                    <div className="text-danger text-center ">
                                                        Record Not available
                                                    </div>
                                                }
                                                onDataSizeChange={({ dataSize }) => {
                                                    dispatch(BreadcrumbShowCountlabel(`Count:${dataSize}`));
                                                }}
                                                {...toolkitProps.baseProps}
                                            />
                                            {globalTableSearchProps(toolkitProps.searchProps)}
                                        </div>
                                    </Col>
                                </Row>

                            </React.Fragment>
                        )}
                    </ToolkitProvider> */}


                <GlobalCustomTable
                    keyField="PartyID"
                    data={Data}
                    columns={displayColumns}
                    search

                    classes={"table  table-bordered table-hover"}
                    noDataIndication={
                        <div className="text-danger text-center ">
                            Record Not available
                        </div>
                    }
                    // onDataSizeChange={({ dataSize }) => {
                    //     dispatch(BreadcrumbShowCountlabel(`Count:${dataSize}`));
                    // }}

                    onDataSizeChange={({ dataCount }) => {
                        dispatch(BreadcrumbShowCountlabel(`Count:${dataCount}`));
                    }}
                />

            </div>


        </React.Fragment >
    )
}

export default InvoiceDataExport;